import { Tooltip } from "@mui/material";
import { useAuth } from "../../context/AuthContext";

export const ONLINE_QUERIES_OFF_REASON =
  "Consultas en línea al Poder Judicial desactivadas.";

/**
 * Hook para gatear cualquier acción que consulte al portal judicial.
 *   const { online, offlineReason } = useOnlineQueryGate();
 *   <Button disabled={loading || !online} ... />
 */
export function useOnlineQueryGate() {
  const { onlineQueriesEnabled } = useAuth();
  return {
    online: !!onlineQueriesEnabled,
    offlineReason: onlineQueriesEnabled ? "" : ONLINE_QUERIES_OFF_REASON,
  };
}

/**
 * Envuelve un control (Button, IconButton…) para mostrar el motivo cuando las
 * consultas en línea están desactivadas. El <span> es necesario para que el
 * Tooltip funcione sobre un elemento disabled.
 *
 *   <OnlineQueryTooltip show={!online}>
 *     <Button disabled={!online || loading}>Actualizar</Button>
 *   </OnlineQueryTooltip>
 */
export default function OnlineQueryTooltip({ show, block = false, children }) {
  if (!show) return children;
  return (
    <Tooltip title={ONLINE_QUERIES_OFF_REASON} arrow disableInteractive>
      <span
        style={{
          display: block ? "block" : "inline-flex",
          width: block ? "100%" : undefined,
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
}
